<template>
    <div 
        ref="stepsContainer"
        class="o-d-path-steps d-path-steps"
    >
        <button
            :id="`path-step-${index}`"
            class="d-path-steps__button"
            :class="{ 'd-path-steps__button--active': index === activeStepIndex }"
            type="button"
            role="button"
            v-for="(item, index) in path"
            :key="index"
            @click="setActiveStepAndIndex(index)"
        >
            <span class="d-path-steps__index">
                {{ index + 1}}
            </span>
            <!--<svg-icon
                v-if="index === path.length - 1 && index === activeStepIndex"
                original
                name="navigation/w-finish"
                class="d-path-steps__icon"
            />-->
            <svg-icon
                v-if="['up','down'].includes(item.direction)"
                original
                :name="`navigation/${item.direction}-dark`"
                class="d-path-steps__icon"
            />
            <svg-icon
                v-else-if="index === path.length - 1"
                original
                name="navigation/finish"
                class="d-path-steps__icon"
            />
            <svg-icon
                v-else
                original
                :name="`navigation/${item.direction}`"
                class="d-path-steps__icon d-path-steps__icon-dark"
            />
            <span class="d-path-steps__wrapper">
                <OStepText
                    class="d-path-steps__step"
                    :step="item"
                />
            </span>
            <span class="d-path-steps__distance">
                {{ t(item, 'distance') }} {{ $t('ui.meter')}}
            </span>
            <svg-icon
                original
                name="icons/arrow-right-dark"
                class="d-path-steps__arrow"
            />
        </button>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import OStepText from '../../unique-organisms/o-step-text/o-step-text';

import { DROP_OVERLAY } from '../../../utils/constants/bus-events-constants';

import {
    UI_STEP_SELECTED,
    MAP_SHOW_PATH_STEPS
} from "../../../shared/components/map-viewer/constants/map-events";

export default {
    name: 'ODPathSteps',
    components: {
        OStepText
    },
    computed: {
        ...mapState({
            path: state => state.activePath?.steps,
            activeStepIndex: state => state.activeStepIndex
        }),
        ...mapGetters([
            't',
            'getMvData'
        ])
    },
    mounted() {
        this.initEventListeners();
    },
    updated() {
        this.$nextTick(() => this.alignElements());
    },
    beforeDestroy() {
        this.deactivateEventsListeners();
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_STEP_SELECTED, this.setSelectedStep);
        },
        deactivateEventsListeners() {
            this.$bus.$off(UI_STEP_SELECTED, this.setSelectedStep);
        },
        setActiveStepAndIndex(index) {
            this.$bus.$emit(MAP_SHOW_PATH_STEPS, index);
            this.$store.commit('setActiveStepIndex', index);
            this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
            this.$bus.$emit(DROP_OVERLAY, true);
            document.getElementById(`path-step-${index}`).scrollIntoView({ behavior: 'smooth', block: 'center'});
        },
        setSelectedStep(index) {
            this.$store.commit('setActiveStepIndex', index);
            this.$store.commit('setActiveStep', this.path[this.activeStepIndex]);
        },
        alignElements() {
            const containerHeight = +this.$refs.stepsContainer.offsetHeight
            const arr = [...document.getElementsByClassName('d-path-steps__button')];
            const values = [];

            arr.forEach(item => {
                values.push(parseInt(item.offsetHeight));
            });

            if( containerHeight < Math.max(...values)*values.length && containerHeight > values.reduce((result, num) => result + num, 0) ) {
                return
            } else {
                arr.forEach(item => {
                    item.style.height = Math.max(...values) + 'px';
                });
            }

        }
    }
}
</script>

<style lang="scss">
@import "o-d-path-steps";   
</style>
